import { jsx as _jsx } from "react/jsx-runtime";
import { Switch as AriaSwitch } from 'react-aria-components';
import { cn } from '../../utils';
export function Switch({ value, onChange, id, disabled }) {
    return (_jsx(AriaSwitch, { id: id, isSelected: value, onChange: onChange, isDisabled: disabled, className: cn('group inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-pill p-stack-dense transition-colors duration-control', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-border-focus focus-visible:outline-offset-2', 'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50', {
            'bg-brand': value,
            'bg-border-strong': !value,
        }), children: _jsx("span", { className: cn('pointer-events-none block size-5 shrink-0 rounded-pill bg-surface shadow transition-all duration-control ease-enter', 'group-data-[disabled]:opacity-50', {
                'translate-x-5': value,
                'translate-x-0': !value,
            }) }) }));
}
